<template>
    <nav class="navigation-bottom" aria-label="Bottom navigation">
        <div class="row navigation-bottom__container">
            <div class="col-default-8 col-tablet-12 navigation-bottom__item">
                <ul class="navigation-bottom__main">
                    <li v-for="(item, index) in data.main" :key="index">
                        <a :href="item.link" :title="item.name" v-html="item.name"></a>
                    </li>
                </ul>
            </div>
            <div class="col-default-4 col-tablet-12">
                <ul class="navigation-bottom__main navigation-bottom__main--last">
                    <li v-for="(item, index) in data.second" :key="index">
                        <a :href="item.link" :title="item.name" v-html="item.name" :target="item.params && item.params.BLANK ? '_blank' : false"></a>
                    </li>
                </ul>
            </div>
            <div class="col-default-12 col-tablet-8 col-mobile-12 navigation-bottom__interfacs">
                <h6 class="navigation-bottom__subscribtion-title">
                   {{ text.interfacs.title }}
                </h6>
                <z-link
                    href="https://e-disclosure.ru/portal/company.aspx?id=942&attempt=1"
                    external
                >
                    {{ text.interfacs.link }}
                </z-link>
            </div>
            <div class="col-default-8 col-tablet-8 col-mobile-12 navigation-bottom__subscribtion">
                <h6 class="navigation-bottom__subscribtion-title">
                    {{ text.subscription }}
                </h6>
                <div class="navigation-bottom__subscribtion-wrapper">
                    <z-input
                        class="navigation-bottom__subscribtion-input"
                        name="email"
                        type="email"
                        required
                        placeholder="Email"
                        @input="email = $event"
                        @isValid="isValid = $event"
                    ></z-input>
                    <button class="navigation-bottom__subscribtion-button" :class="{'navigation-bottom__subscribtion-button--active': isValid}" @click="subscribe">
                        <z-icon
                            name="arrow"
                            dir="right"
                            width="24"
                            height="24"
                        >
                        </z-icon>
                    </button>
                </div>
            </div>
            <div class="col-default-3 col-default-offset-1 col-mobile-12 col-mobile-offset-0 navigation-bottom__subscribtion">
                <div class="navigation-bottom__external-wrapper">
                    <ul class="navigation-bottom__external" v-if="data['external-links']">
                        <li v-for="(item, index) in data['external-links']" :key="index">
                            <a
                                :href="item.link"
                                :title="item.name"
                                v-html="item.name"
                                target="_blank"
                            ></a>
                        </li>
                    </ul>
                    <social class="navigation-bottom__social" :links="social.links" showCaption direction="horizontal" />
                </div>
            </div>
        </div>
    </nav>
</template>

<script>
import { localize } from '@/utils/i18n.js'

export default {
    name: 'navigation-bottom',
    data () {
        return {
            data: this.$root.app.components.navigation.bottom,
            social: {
                links: [
                    {
                        link: 'https://vk.com/club185711935',
                        icon: 'social/vk'
                    },
                    {
                        link: 'https://t.me/raspadskaya_ru',
                        icon: 'social/tg'
                    }
                ]
            },
            email: '',
            isValid: false,
            text: {
                subscription: localize({
                    ru: 'Подпишитесь на новостную рассылку:',
                    en: 'Subscribe to the newsletter:'
                }),
                interfacs: {
                    title: localize({
                        ru: 'Раскрытие информации:',
                        en: 'Disclosure of Information:'
                    }),
                    link: localize({
                        ru: 'ООО «Интерфакс-ЦРКИ»',
                        en: 'Interfax-CDC LLC'
                    })
                }
            }
        }
    },
    methods: {
        subscribe () {
            if (!this.isValid) return
            window.location.href = '/' + this.$root.app.page.lang + '/press-center/subscription/?email=' + this.email
        }
    }
}
</script>

<style lang="scss" src="./index.scss"></style>
